module.exports = __webpack_public_path__ + "af4f4505.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/validacion green.png
// module id = 1200
// module chunks = 0 1 2